'use strict';

angular.module('msProfile').constant('customizationOptions', {
  STANDARD: {
    sections: [{
      name: 'healthTopic',
      values: ['condition:depression', 'condition:anxiety', 'condition:drugs_and_alcohol', 'condition:chronic_pain', 'condition:mindfulness_and_stress_reduction', 'condition:insomnia', 'health_topic:adhd', 'condition:ptsd', 'condition:bipolar_disorder', 'condition:pregnancy_and_early_parenting', 'health_topic:eating_disorders', 'lifestyle:grief', 'lifestyle:caregiving']
    }, {
      name: 'physicalWellness',
      values: ['health_topic:weight_management', 'health_topic:eating_well', 'health_topic:physical_fitness', 'health_topic:getting_active', 'condition:nicotine']
    }, {
      name: 'relationships',
      values: ['lifestyle:divorce', 'lifestyle:marriage', 'lifestyle:widow', 'lifestyle:friendship', 'lifestyle:work_relations', 'lifestyle:lgbt']
    }]
  },

  WELLNESS: {
    sections: [{
      name: 'healthTopic',
      values: ['condition:depression', 'condition:anxiety', 'condition:drugs_and_alcohol', 'condition:chronic_pain', 'condition:mindfulness_and_stress_reduction', 'condition:insomnia', 'condition:ptsd', 'condition:pregnancy_and_early_parenting', 'lifestyle:grief', 'lifestyle:caregiving']
    }, {
      name: 'physicalWellness',
      values: ['health_topic:weight_management', 'health_topic:eating_well', 'health_topic:physical_fitness', 'health_topic:getting_active', 'condition:nicotine']
    }, {
      name: 'relationships',
      values: ['lifestyle:divorce', 'lifestyle:marriage', 'lifestyle:widow', 'lifestyle:friendship', 'lifestyle:work_relations', 'lifestyle:lgbt']
    }]
  },
  SLIM_MDD: {
    sections: [{
      name: 'healthTopic',
      values: ['condition:depression', 'condition:anxiety']
    }]
  }
});